import { render, staticRenderFns } from "./P1.vue?vue&type=template&id=3694ae1f"
import script from "./P1.vue?vue&type=script&lang=js"
export * from "./P1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports